import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import type { TextFieldProps } from "@mui/material/TextField";

import { PublicSvgIcon } from "~/components/public_svg_icon";
import { TextInput } from "~/components/text_input";

export type CopyableTextInputProps = {
  value: string | number;
  dataTestId?: string;
} & TextFieldProps;

export function CopyableTextInput({
  value,
  dataTestId: dataTestId,
  ...rest
}: CopyableTextInputProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value.toString());
    } catch (err) {
      console.error("Couldn't copy value to clipboard:", err);
    }
  };
  return (
    <TextInput
      value={value}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                tabIndex={-1}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy();
                }}
              >
                <PublicSvgIcon name="content_copy_duplicate" />
              </IconButton>
            </InputAdornment>
          ),
          inputProps: {
            "data-testid": dataTestId,
          },
        },
      }}
      {...rest}
    />
  );
}
